import { CloseAll, setOpenARMainMenu, setOpenChoiceComponentAR, setOpenEnteringDataAR, setOpenLogin, setOpenOptionMenu, setOpenOtherMenu, setOpenRevenueButtonsMenu, setOpenSummaryReport, TransitionSystem } from "./Reducer/ModalSlice";
import { clearUser, setLogOut } from "./Reducer/UserSlice";
import { ClearSelectedCity } from "./Reducer/CitySlice";
import { ClearSelectedMonth } from "./Reducer/MonthSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { ClearSelectedMonthAR } from "./Reducer/MonthSliceAR";
import { roleId } from "./Components/Constants/app";
import { clearRevenueModule } from "./Reducer/RevenueModuleSlice";

function Header(){
const OpenModal = useSelector(state => state.ModalSlice.OpenModal)
    
const User = useSelector(state => state.UserSlice.User)

const [CancelTouch, setCancelTouch] = useState(false)

const dispatch = useDispatch()
    
if(!OpenModal.OpenLogin)
return(
        <div
        className="HeaderMain"
        >
            <div
            className="HeaderLeftPart"
            onClick={(() => {
              if(window.matchMedia('(max-width: 740px)').matches)
              {
                if(OpenModal.OpenChoiceComponentAR)
                  dispatch(setOpenARMainMenu(false))
                if(OpenModal.OpenMainMenu)
                  dispatch(setOpenOptionMenu(false))
                if(OpenModal.OpenRevenue)
                  dispatch(setOpenRevenueButtonsMenu(false))
                if(!OpenModal.OpenMainMenu && !OpenModal.OpenRevenue && !OpenModal.OpenChoiceComponentAR)
                  dispatch(setOpenOtherMenu(false))
              }
            })}
            onTouchStart={() => {
              setCancelTouch(false)
            }}
            onTouchMove={() => {
                setCancelTouch(true)
            }}
            onTouchCancel={() => {
                setCancelTouch(true)
            }}
            onTouchEnd={((event) => {
              if(window.matchMedia('(max-width: 740px)').matches)
              {
                event.preventDefault()
                if(!CancelTouch)
                {
                  if(OpenModal.OpenChoiceComponentAR)
                    dispatch(setOpenARMainMenu(false))
                  if(OpenModal.OpenMainMenu)
                    dispatch(setOpenOptionMenu(false))
                  if(OpenModal.OpenRevenue)
                    dispatch(setOpenRevenueButtonsMenu(false))
                  if(!OpenModal.OpenMainMenu && !OpenModal.OpenRevenue && !OpenModal.OpenChoiceComponentAR)
                    dispatch(setOpenOtherMenu(false))
                }
              }
            })}
            >
            {(!OpenModal.OpenLogin && !OpenModal.OpenChoiceSystem) && 
            <div
            className="BurgerMain"
            onClick={((event) => {
              event.stopPropagation()
              if(OpenModal.OpenChoiceComponentAR)
                dispatch(setOpenARMainMenu(!OpenModal.OpenARMainMenu))
              if(OpenModal.OpenMainMenu)
                dispatch(setOpenOptionMenu(!OpenModal.OpenOptionMenu))
              if(OpenModal.OpenRevenue)
                dispatch(setOpenRevenueButtonsMenu(!OpenModal.OpenRevenueButtonsMenu))
              if(!OpenModal.OpenMainMenu && !OpenModal.OpenRevenue && !OpenModal.OpenChoiceComponentAR)
                dispatch(setOpenOtherMenu(!OpenModal.OpenOtherMenu))
            })}
            onTouchStart={() => {
              setCancelTouch(false)
            }}  
            onTouchMove={() => {
                setCancelTouch(true)
            }}
            onTouchCancel={() => {
                setCancelTouch(true)
            }}
            onTouchEnd={((event) => {
              event.stopPropagation()
              event.preventDefault()
              if(!CancelTouch)
              {
                if(OpenModal.OpenChoiceComponentAR)
                  dispatch(setOpenARMainMenu(!OpenModal.OpenARMainMenu))
                if(OpenModal.OpenMainMenu)
                  dispatch(setOpenOptionMenu(!OpenModal.OpenOptionMenu))
                if(OpenModal.OpenRevenue)
                  dispatch(setOpenRevenueButtonsMenu(!OpenModal.OpenRevenueButtonsMenu))
                if(!OpenModal.OpenMainMenu && !OpenModal.OpenRevenue && !OpenModal.OpenChoiceComponentAR)
                  dispatch(setOpenOtherMenu(!OpenModal.OpenOtherMenu))
              }
            })}
            >         
              <div className={(OpenModal.OpenOptionMenu || OpenModal.OpenRevenueButtonsMenu || OpenModal.OpenOtherMenu || OpenModal.OpenARMainMenu) ? "BurgerPart Active" : "BurgerPart"}/>
              <div className={(OpenModal.OpenOptionMenu || OpenModal.OpenRevenueButtonsMenu || OpenModal.OpenOtherMenu || OpenModal.OpenARMainMenu) ? "BurgerPart Active" : "BurgerPart"}/>
              <div className={(OpenModal.OpenOptionMenu || OpenModal.OpenRevenueButtonsMenu || OpenModal.OpenOtherMenu || OpenModal.OpenARMainMenu) ? "BurgerPart Active" : "BurgerPart"}/>
            </div>
            }
  
            <div
            className="HeaderIconDiv"
            />
              {OpenModal.SelectedSystem === 'AR' && [roleId.admin, roleId.operatingDirector, roleId.director].includes(User.user.role.id) && (OpenModal.OpenEnteringDataAR || OpenModal.OpenSummaryReport) &&
              <div    
              className="RevenueUpButtonsDiv Close"
              >
                  <button
                  className="RevenueMenuButton"
                  onClick={(() => {
                    dispatch(setOpenEnteringDataAR(false))
                    dispatch(setOpenSummaryReport(false))
                    dispatch(ClearSelectedCity())
                    dispatch(ClearSelectedMonthAR())
                    dispatch(setOpenChoiceComponentAR(true))
                  })}
                  onTouchStart={() => {
                    setCancelTouch(false)
                  }}
                  onTouchMove={() => {
                      setCancelTouch(true)
                  }}
                  onTouchCancel={() => {
                      setCancelTouch(true)
                  }}
                  onTouchEnd={((event) => {
                    event.stopPropagation()
                    event.preventDefault()
                    if(!CancelTouch)
                    {
                      dispatch(setOpenEnteringDataAR(false))
                      dispatch(ClearSelectedCity())
                      dispatch(ClearSelectedMonthAR())
                      dispatch(setOpenSummaryReport(false))
                      dispatch(setOpenChoiceComponentAR(true))
                    }
                  })}
                  >
                      Главное меню
                  </button>
              </div>}
          </div>
          
          <div
          className={(!OpenModal.OpenStaffManagment && !OpenModal.OpenRevenue) ? "ExitMainDiv" : 'ExitMainDiv OpenModal.OpenRevenue'}
          >
            {!OpenModal.OpenStaffManagment && !OpenModal.OpenRevenue && OpenModal.SelectedSystem && User.user.role.id !== roleId.cashier &&
            <button
            className="ExitButton BetweenSystems"
            onClick={(async () => {
              await dispatch(TransitionSystem())
              await dispatch(setOpenLogin(false))
              dispatch(ClearSelectedCity())
              dispatch(ClearSelectedMonth())
              dispatch(clearRevenueModule())
            })}
            onTouchStart={() => {
              setCancelTouch(false)
            }}
            onTouchMove={() => {
                setCancelTouch(true)
            }}
            onTouchCancel={() => {
                setCancelTouch(true)
            }}
            onTouchEnd={(async (event) => {
              event.preventDefault()
              if(!CancelTouch)
              {
                await dispatch(TransitionSystem())
                dispatch(ClearSelectedCity())
                dispatch(ClearSelectedMonth())
                dispatch(clearRevenueModule())
              }
            })}
            >
              Выбор модуля
            </button>}
            
            <div
            className="ExitUserNameDiv"
            > 
              {User.user.FIO}
            </div>
  
            {!OpenModal.OpenStaffManagment && !OpenModal.OpenRevenue && 
            <button
            className="ExitButton"
            onClick={(() => {
              dispatch(CloseAll())
              dispatch(clearUser())
              dispatch(ClearSelectedCity())
              dispatch(ClearSelectedMonth())
              dispatch(ClearSelectedMonthAR())
              dispatch(setLogOut(true))
            })}
            onTouchStart={() => {
              setCancelTouch(false)
            }}
            onTouchMove={() => {
                setCancelTouch(true)
            }}
            onTouchCancel={() => {
                setCancelTouch(true)
            }}
            onTouchEnd={((event) => {
              event.preventDefault()
              if(!CancelTouch)
              {
                dispatch(CloseAll())
                dispatch(clearUser())
                dispatch(ClearSelectedCity())
                dispatch(ClearSelectedMonth())
                dispatch(ClearSelectedMonthAR())
                dispatch(setLogOut(true))
              }
            })}
            >
              Выйти
            </button>
          }
          </div>
        </div>
    )
}

export default Header;
